import { render, staticRenderFns } from "./skd.vue?vue&type=template&id=58b8155c&"
import script from "./skd.vue?vue&type=script&lang=js&"
export * from "./skd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports